import { render, staticRenderFns } from "./EditTractStatus.vue?vue&type=template&id=736e14d2&"
import script from "./EditTractStatus.vue?vue&type=script&lang=js&"
export * from "./EditTractStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports